// import React from "react";
// import { Button } from "@mui/material";
// import { styled } from "@mui/material/styles";

// const StyledButton = styled(Button)(({ theme }) => ({
//   background: "#02462E",
//   color: "#FCFCFC",
//   fontFamily: "DM Sans, sans-serif",
//   fontWeight: 700,
//   fontSize: "24px",
//   lineHeight: "24px",
//   letterSpacing: "-2%",
//   textAlign: "left",
//   flexWrap: "nowrap",
//   textTransform: "none",
//   padding: "12px 24px",
//   borderRadius: "10px",
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   width: "707px",
//   height: "64px",
//   marginBottom: "16px",
//   boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
//   "&:hover": {
//     background: "linear-gradient(180deg, #2C3890 0%, #0B1356 100%)",
//   },
//   "&:disabled": {
//     background: "linear-gradient(180deg, #9CA3AF 0%, #6B7280 100%)",
//     color: "#D1D5DB",
//   },
//   "& .arrow": {
//     marginLeft: "auto",
//     fontSize: "24px",
//     lineHeight: "24px",
//   },
//   animation: "moveInRight 300ms ease-out",

//   [theme.breakpoints.down("sm")]: {
//     width: "100%",
//     maxWidth: "100%",
//     height: "auto",
//     fontSize: "18px",
//     lineHeight: "22px",
//     padding: "10px 16px",
//     flexWrap: "wrap",
//     whiteSpace: "normal",
//   },
// }));

// const styles = `
//   @keyframes moveInRight {
//     from {
//       transform: translateX(100%);
//       opacity: 0;
//     }
//     to {
//       transform: translateX(0);
//       opacity: 1;
//     }
//   }
// `;

// if (typeof document !== "undefined") {
//   const styleSheet = document.createElement("style");
//   styleSheet.textContent = styles;
//   document.head.appendChild(styleSheet);
// }

// export default function DownloadZipButton({ config, title, externalHref }) {
//   const handleClick = () => {
//     if (externalHref) {
//       window.open(externalHref, "_blank", "noopener,noreferrer");
//     }

//     // Download the file after
//     const link = document.createElement("a");
//     link.href = config.downloadUrl;
//     link.setAttribute("download", config.name);
//     document.body.appendChild(link);
//     link.click();
//     link.remove();
//   };

//   const displayTitle = title || `Download ${config.name}`;

//   return (
//     <StyledButton onClick={handleClick}>
//       {displayTitle}
//       <span className="arrow">→</span>
//     </StyledButton>
//   );
// }
import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#02462E",
  color: "#FCFCFC",
  fontFamily: "DM Sans, sans-serif",
  fontWeight: 700,
  fontSize: "24px",
  lineHeight: "24px",
  letterSpacing: "-2%",
  textAlign: "left",
  flexWrap: "nowrap",
  textTransform: "none",
  padding: "12px 24px",
  borderRadius: "10px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "707px",
  height: "64px",
  marginBottom: "16px",
  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.15)",
  "&:hover": {
    color: "#02462E",
    background: "#FEC700",
    boxShadow: "0px 4px 12px rgba(254, 199, 0, 0.4)",
  },
  "&:disabled": {
    background: "linear-gradient(180deg, #9CA3AF 0%, #6B7280 100%)",
    color: "#D1D5DB",
  },
  "& .arrow": {
    marginLeft: "auto",
    fontSize: "24px",
    lineHeight: "24px",
  },
  animation: "moveInRight 300ms ease-out",

  [theme.breakpoints.down("sm")]: {
    width: "100%",
    maxWidth: "100%",
    height: "auto",
    fontSize: "18px",
    lineHeight: "22px",
    padding: "10px 16px",
    flexWrap: "wrap",
    whiteSpace: "normal",
  },
}));

const styles = `
  @keyframes moveInRight {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}

export default function DownloadZipButton({ config, title, externalHref }) {
  const handleClick = () => {
    console.log(`Opening external link: ${externalHref}`);
    // First, open external link if provided
    if (externalHref) {
      window.open(externalHref, "_blank", "noopener,noreferrer");
    }

    // Only attempt download if downloadUrl exists
    if (config.downloadUrl) {
      const link = document.createElement("a");
      link.href = config.downloadUrl;
      link.setAttribute("download", config.name);
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  };

  const displayTitle = title || `Download ${config.name}`;

  return (
    <StyledButton onClick={handleClick}>
      {displayTitle}
      <span className="arrow">→</span>
    </StyledButton>
  );
}
